import React, { RefObject } from "react"
import { TourStep } from "../TourDocument"

export interface InvoiceUpdateFormTourRefs {
    mainFields: RefObject<HTMLDivElement>
    pricingModel: RefObject<HTMLDivElement>
    accompanyingDocuments: RefObject<HTMLDivElement>
    goodsSelection: RefObject<HTMLDivElement>
    positionEditPanel: RefObject<HTMLDivElement>
    pricesAccordion: RefObject<HTMLDivElement>
    actionButtons: RefObject<HTMLDivElement>
    searchOption: RefObject<HTMLDivElement>
    itemsGrid: RefObject<HTMLDivElement>
}

export const getInvoiceUpdateFormTourSteps = (refs: InvoiceUpdateFormTourRefs): TourStep[] => [
    {
        target: () => refs.mainFields.current,
        description: "Для создания приходной накладной заполняем все необходимые поля.",
        placement: "bottom",
    },
    {
        target: () => refs.pricingModel.current,
        description: "Выбираем модель ценообразования. Нажимаем Enter.",
        placement: "bottom",
    },
    {
        target: () => refs.accompanyingDocuments.current,
        description: "Для внесения информации по сопроводительным документам от поставщика разворачиваем вкладку. В открывшейся вкладке заполняем все необходимые поля.",
        placement: "top",
    },
    {
        target: () => refs.goodsSelection.current,
        description: 'Подбор товара в приходную накладную осуществляется из справочника "Номенклатура". Выбираем товар и добавляем в документ нажав на кнопку "ОК" или клавишу Enter.',
        placement: "top",
    },
    {
        target: () => refs.positionEditPanel.current,
        description: "Так же подбор возможен по коду и штрих-коду товара.",
        placement: "top",
    },
    {
        target: () => refs.pricesAccordion.current,
        description: "При развернутом аккордеоне отображается информация о суммах документа и средней наценке.",
        placement: "top",
    },
    {
        target: () => refs.actionButtons.current,
        description: 'После заполнения всех необходимых полей и подбора товара, нажимаем "ОК" или "Сохранить".',
        placement: "top",
    },
    {
        description: "Убедитесь, что в настройках импорта накладной включена опция «Загрузка GTIN от поставщика». Это необходимо для автоматической привязки КИЗов к товарам.",
        placement: "over",
    },
    {
        target: () => refs.searchOption.current,
        description: "Откройте импортированную накладную. Установите фильтр - «КИЗ/SSCC». Фильтр необходим для корректного распознавания кодов маркировки.",
        placement: "top",
    },
    {
        target: () => refs.goodsSelection.current,
        description: 'Последовательно сканируйте все коды маркировки в поле "Подбор товара".',
        placement: "top",
    },
    {
        target: () => refs.itemsGrid.current,
        description: (
            <div>
                Система автоматически:
                <ul>
                    <li>Проверит формат кода</li>
                    <li>Определит GTIN</li>
                    <li>Свяжет КИЗ с товаром</li>
                </ul>
            </div>
        ),
        placement: "top",
    },
    {
        target: () => refs.itemsGrid.current,
        description: (
            <div>
                В данной таблице можно отфильтровать данные так как вам угодно, для этого нужно:
                <ol>
                    <li>Нажать на название любой колонки, после чего откроется поле ввода</li>
                    <li>Ввести любой текст</li>
                </ol>
                Система автоматически отфильтрует данные ориентируясь по введенному ранее тексту
            </div>
        ),
        placement: "top",
    },
]
